import { z } from 'zod';

export type InsulationMaterialType = 'PVC' | 'XLPE';

type InsulationMaterialOption = {
    value: InsulationMaterialType;
    label: string;
    maxTemperature: number; // in °C
};

const options: InsulationMaterialOption[] = [
    { value: 'PVC', label: 'PVC', maxTemperature: 70 },
    { value: 'XLPE', label: 'XLPE', maxTemperature: 90 },
    // { value: 'EPR', label: 'EPR (Ethylene Propylene Rubber)', maxTemperature: 90 },
    // { value: 'PE', label: 'PE (Polyethylene)', maxTemperature: 75 },
    // { value: 'PTFE', label: 'PTFE (Teflon)', maxTemperature: 200 },
    // { value: 'silicone', label: 'Silicone', maxTemperature: 180 },
    // { value: 'rubber', label: 'Rubber', maxTemperature: 90 },
    // { value: 'fiberglass', label: 'Fiberglass', maxTemperature: 200 },
    // { value: 'paper', label: 'Paper (Oil-Impregnated)', maxTemperature: 105 },
    // { value: 'bare', label: 'No Insulation (Bare Conductor)', maxTemperature: 0 },
];

const validator = z.enum(['PVC', 'XLPE']);

function getMaxTemperature(type: InsulationMaterialType): number {
    return options.find((opt) => opt.value === type)?.maxTemperature ?? 0;
}

export const InsulationMaterial = {
    validator,
    options,
    getMaxTemperature,
};
